module.exports = __webpack_public_path__ + "img/red-uniform.0c270059.png";